var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "public_notes_wrap" }, [
    _c("div", { staticClass: "public_notes_title" }, [
      _c("h2", [_vm._v("公开笔记总数排行")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "public_notes_search" },
        [
          _c("el-input", {
            attrs: {
              clearable: "",
              placeholder: "请输入学生姓名或学号",
              "prefix-icon": "el-icon-search",
              maxlength: "20"
            },
            on: { change: _vm.getSearch },
            model: {
              value: _vm.studentName,
              callback: function($$v) {
                _vm.studentName = $$v
              },
              expression: "studentName"
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            { staticClass: "go_back", on: { click: _vm.getSearch } },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { staticClass: "go_back", on: { click: _vm.goBack } },
            [_vm._v("返回")]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        staticClass: "public_notes_main",
        style: "height:" + (_vm.height - 150) + "px"
      },
      [
        _c(
          "el-table",
          {
            staticClass: "collegeTable",
            staticStyle: { width: "100%", "margin-top": "16px" },
            attrs: {
              data: _vm.tableData,
              "header-cell-style": { background: "#EDF4FE" },
              height: _vm.tableData.length
                ? _vm.height - 200
                : _vm.height - 160,
              "default-sort": { prop: "num", order: "descending" }
            },
            on: { "sort-change": _vm.sortChange }
          },
          [
            _c("el-table-column", { attrs: { prop: "sort", label: "名次" } }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "name", label: "姓名" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c("span", [
                        _vm._v(_vm._s(scope.row.name ? scope.row.name : "——"))
                      ])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "jobNumber", label: "学号" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            scope.row.jobNumber ? scope.row.jobNumber : "——"
                          )
                        )
                      ])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "num",
                label: "公开笔记数",
                sortable: "custom",
                "sort-orders": ["ascending", "descending"]
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.tableData.length
          ? _c("Pagination", {
              attrs: {
                currentpage: _vm.pageTotal.currentPage,
                limit: _vm.pageTotal.pageSize,
                total: _vm.pageTotal.total,
                layout: "sizes, prev, pager, next, jumper",
                small: true
              },
              on: {
                handleCurrentChange: _vm.handleCurrentChange,
                handleSizeChange: _vm.handleSizeChange
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02f13dc9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02f13dc9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/new_educa_module/educa/classStatistics/comp/publicNoteList.vue
// module id = null
// module chunks = 